export default __webpack_public_path__ + "static/media/nat_xl.ea4401a3.jpg";